// @flow
import { useEffect, useState } from 'react';

export const useDelay = (delay: number = 500) => {
  const [isExpired, setIsExpired] = useState<boolean>(false);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setIsExpired(true);
      clearTimeout(timeoutId);
    }, delay);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [delay]);

  return isExpired;
};
